function changeCategory(selectedCategory) {
  const allAccordions = document.querySelectorAll('.container-accordion-categories');
  allAccordions.forEach((accordion) => {
    accordion.classList.add('hide-accordion');
    accordion.classList.add('hidden');
  });
  document.querySelectorAll(`.container-accordion-categories.accordion-category--${selectedCategory}`).forEach((accordion) => {
    accordion.classList.remove('hidden');
    accordion.classList.remove('hide-accordion');
  });
}

const allCategories = document.querySelectorAll('.faq-categories .category input[type="radio"]');
allCategories.forEach((category) => {
  category.addEventListener('click', (element) => {
    const selectedCategory = element.target.getAttribute('target-accordion');
    changeCategory(selectedCategory);
  });
})